import React, { Fragment } from 'react';
import { Footer } from '../../components/Footer';
import { Line } from '../../components/Line';
import { Section } from '../../components/Section';
import { withErrorBoundary } from '../../error-handling/withErrorBoundary';
import {
  withBreakpoints,
  WithBreakpointsProps
} from '../../provider/BreakpointProvider/withBreakpoints';
import {
  selectIsPathContentLoaded,
  selectMenu
} from '../../provider/Typo3Provider/selectors';
import {
  withTypo3,
  WithTypo3Props
} from '../../provider/Typo3Provider/withTypo3';
import BrandsContainer from './BrandsContainer';
import LinksContainer from './LinksContainer';
import LinksContainerMobile from './LinksContainerMobile';
import ServiceContainer from './ServiceContainer';

interface FooterContainerProps {}

const FooterContainer = ({
  typo3,
  breakpoints
}: FooterContainerProps & WithTypo3Props & WithBreakpointsProps) => {
  const isPathContentLoaded = selectIsPathContentLoaded(typo3);
  const { large } = breakpoints;
  const LinksContainerWrapper = large ? Section : Fragment;
  if (isPathContentLoaded) {
    const serviceEntries = selectMenu(typo3, 'service');
    const contactPage = selectMenu(typo3, 'contactpage');

    return (
      <Footer className="hide-for-print">
        <LinksContainerWrapper>
          {large ? <LinksContainer /> : <LinksContainerMobile />}
        </LinksContainerWrapper>
        <Section>
          <Line footer />
          <BrandsContainer />
        </Section>
        <ServiceContainer
          serviceEntries={
            large ? serviceEntries : contactPage.concat(serviceEntries)
          }
        />
      </Footer>
    );
  }
  return null;
};

export default withErrorBoundary(
  withBreakpoints(withTypo3(FooterContainer)),
  'FooterContainer'
);
